module.exports = __webpack_public_path__ + "static/media/ROUNDED.0bf677dd.svg";